import { render, staticRenderFns } from "./SectionMapLocations.vue?vue&type=template&id=683248ca&"
import script from "./SectionMapLocations.vue?vue&type=script&lang=js&"
export * from "./SectionMapLocations.vue?vue&type=script&lang=js&"
import style0 from "./SectionMapLocations.vue?vue&type=style&index=0&id=683248ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsPortfolioOrganismMainLocations: require('/app/components/organisms/portfolio/OrganismMainLocations.vue').default})
